export default __webpack_public_path__ + "static/media/arrowUp.187b746a.svg";